<template>
  <div class="carrier">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Carrier'
}
</script>
